import React from 'react'

import { Loader } from '@/components/loaders/Loader'
import NoData from '@/components/NoData'
import { Card } from '@/components/cards/Card'

const ScorecardGraphContainer = ({ loading, noData, graph, title, info, subTitle, dataTestId }) => {
  const renderWidget = () => {
    if (loading) {
      return (
        <div data-testid="widget-loading" className="empty-table">
          <Loader />
        </div>
      )
    }

    if (noData) {
      return (
        <div className="empty-table">
          <NoData />
        </div>
      )
    }

    return graph
  }

  return (
    <Card title={title} info={info} subtitle={subTitle} data-testid={dataTestId}>
      {renderWidget()}
    </Card>
  )
}

export default ScorecardGraphContainer
